var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4097 13.9247C28.4247 14.1351 28.4247 14.3455 28.4247 14.556C28.4247 20.974 23.5397 28.3692 14.6115 28.3692C11.8609 28.3692 9.30565 27.5725 7.15625 26.1897C7.54706 26.2348 7.92279 26.2498 8.32864 26.2498C10.5982 26.2498 12.6875 25.4833 14.356 24.1756C12.2216 24.1305 10.4329 22.7327 9.81666 20.8087C10.1173 20.8538 10.4179 20.8839 10.7336 20.8839C11.1694 20.8839 11.6054 20.8237 12.0112 20.7186C9.78663 20.2676 8.11818 18.3136 8.11818 15.9538V15.8937C8.76447 16.2544 9.51607 16.4799 10.3126 16.5099C9.00496 15.6381 8.14825 14.1501 8.14825 12.4667C8.14825 11.5648 8.38869 10.7381 8.80958 10.0167C11.1995 12.9627 14.7918 14.8866 18.82 15.097C18.7449 14.7363 18.6998 14.3606 18.6998 13.9848C18.6998 11.3093 20.8642 9.12988 23.5547 9.12988C24.9525 9.12988 26.2151 9.71608 27.1019 10.663C28.1991 10.4526 29.2513 10.0467 30.1832 9.49062C29.8224 10.6179 29.0559 11.5649 28.0489 12.1661C29.0259 12.0609 29.9728 11.7903 30.8446 11.4146C30.1833 12.3765 29.3566 13.2332 28.4097 13.9247V13.9247Z",
    fill: "#F4F4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6883,
    height: 23.6883,
    fill: "white",
    transform: "translate(7.15625 7.15588)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwt);
export default __webpack_public_path__ + "static/media/twt.2665c9afcc286d883bd81ffeec55cc80.svg";
export { ForwardRef as ReactComponent };